var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormInput',_vm._g(_vm._b({ref:"field",attrs:{"type":"email","validations":_vm.emailValidations,"autocomplete":"username email"}},'FormInput',_vm._props,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }